export default "__VITE_ASSET__CDbI0HWU__"